import { useContext } from 'react';
import { AuthContext } from '@/context/auth.context';
import { useFeatureFlag } from 'src/integrations/feature-flags/feature-flags';

/**
 * Whether the feedback page is reachable: behind the `feedback-triage-enabled`
 * flag and open to every non-restricted user. Without Feedback:Read the page
 * is a read-only view of what they reported, with it the triage dashboard.
 */
export function useCanViewFeedbackPage(): boolean {
  const { currentUser } = useContext(AuthContext);
  const { enabled } = useFeatureFlag('feedback-triage-enabled', false);
  return enabled && !!currentUser && !currentUser.isRestrictedUser;
}
